import { createFormHook } from '@tanstack/react-form';

import {
  Checkbox,
  Combobox,
  ComboboxChips,
  ComboboxInput,
  DatePicker,
  DayChooser,
  Error,
  Field,
  NumberInput,
  NumberInputGroup,
  NumberInputInput,
  NumberInputScrubArea,
  NumberInputTrigger,
  PasswordInput,
  RadioGroup,
  SearchInput,
  Select,
  SelectTrigger,
  Switch,
  TextArea,
  TextInput,
  TokenizedTextArea,
} from './field-components';
import { ResetButton, SubmitButton } from './form-components';
import { fieldContext, formContext } from './form-context';

const { useAppForm, withForm, withFieldGroup, useTypedAppFormContext } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: {
    Checkbox,
    Combobox,
    ComboboxChips,
    ComboboxInput,
    DatePicker,
    DayChooser,
    Error,
    Field,
    NumberInput,
    NumberInputGroup,
    NumberInputInput,
    NumberInputScrubArea,
    NumberInputTrigger,
    PasswordInput,
    RadioGroup,
    SearchInput,
    Select,
    SelectTrigger,
    Switch,
    TextArea,
    TextInput,
    TokenizedTextArea,
  },
  formComponents: {
    ResetButton,
    SubmitButton,
  },
});

export { useAppForm, useTypedAppFormContext, withFieldGroup, withForm };
